import React, { useEffect, useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import Constant from '../../constants';
import { isSmallScreenDevice } from '../Utility';


const DeviceSizeModal = (props) => {

    const { show, setShow, showOnMapLoad, closeMapModel } = props;

    const handleResize = useCallback(() => {
        const flag = isSmallScreenDevice();
        if (setShow)
            setShow(flag);
    }, [setShow]);


    useEffect(() => {
        if (showOnMapLoad) {

            handleResize();
            window.addEventListener('resize', handleResize);

        }

        return () => {

            window.removeEventListener('resize', handleResize);
        };
    }, [showOnMapLoad, handleResize]);

    const handleClose = () => {
        if (closeMapModel) {
            closeMapModel();
        }

        if (setShow)
            setShow(false);
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName='deviceSizeModal'
            backdropClassName='deviceSizeModal-backdrop'
        >
            <Modal.Header >
                <div className='title'></div>
                <button onClick={handleClose} className='closeBtn'
                    aria-label='close the alert banner'>X</button>
            </Modal.Header>
            <Modal.Body>
                <div className='ss-flex'>
                    <i className="bi bi-exclamation-triangle"></i>
                    <p>
                        {Constant.DEVICE_SIZE_MSG}
                    </p>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DeviceSizeModal;